$(function () {
  $('[data-toggle="tooltip"]').tooltip()
  $('[data-toggle="popover"]').popover()
  $('#myButton').on('click', function () {
    var $btn = $(this).button('loading')
    // business logic...
    setTimeout(() => {
      $btn.button('reset')
    }, 1000)
  })
})


// WEBPACK FOOTER //
// ./src/pages/base/develop.js